var map = {
	"./ar.json": 5310,
	"./de.json": 5894,
	"./en.json": 4174,
	"./es.json": 6725,
	"./fr.json": 4605,
	"./it.json": 3672,
	"./ja.json": 7980,
	"./pt.json": 7741,
	"./ru.json": 4600,
	"./th.json": 7549,
	"./tr.json": 9755,
	"./zh.json": 9527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4595;